import { combineReducers } from "redux";
import axios from "axios";
import _ from "lodash";
import { API } from "../../../../const";
import { Service } from "../../../service/service";
import { unAuthorized } from "../../../auth/Auth.ducks";

// Absence actions

export const ADD_POST_PENDING = "ADD_POST_PENDING";
export const ADD_POST_REJECTED = "ADD_POST_REJECTED";
export const ADD_POST_FULFILLED = "ADD_POST_FULFILLED";

export const GET_POST_PENDING = "GET_POST_PENDING";
export const GET_POST_REJECTED = "GET_POST_REJECTED";
export const GET_POST_FULFILLED = "GET_POST_FULFILLED";

export const DELETE_POST_PENDING = "DELETE_POST_PENDING";
export const DELETE_POST_REJECTED = "DELETE_POST_REJECTED";
export const DELETE_POST_FULFILLED = "DELETE_POST_FULFILLED";

export const UPLOAD_IMAGES_PENDING = "UPLOAD_IMAGES_PENDING";
export const UPLOAD_IMAGES_REJECTED = "UPLOAD_IMAGES_REJECTED";
export const UPLOAD_IMAGES_FULFILLED = "UPLOAD_IMAGES_FULFILLED";

export const ADDED_MEDIA_POST_PENDING = "ADDED_MEDIA_POST_PENDING";
export const ADDED_MEDIA_POST_REJECTED = "ADDED_MEDIA_POST_REJECTED";
export const ADDED_MEDIA_POST_FULFILLED = "ADDED_MEDIA_POST_FULFILLED";

export const DELETE_MEDIA_PENDING = "DELETE_MEDIA_PENDING";
export const DELETE_MEDIA_REJECTED = "DELETE_MEDIA_REJECTED";
export const DELETE_MEDIA_FULFILLED = "DELETE_MEDIA_FULFILLED";

export const CHOOSE_FAVORI_PENDING = "CHOOSE_FAVORI_PENDING";
export const CHOOSE_FAVORI_REJECTED = "CHOOSE_FAVORI_REJECTED";
export const CHOOSE_FAVORI_FULFILLED = "CHOOSE_FAVORI_FULFILLED";

export const UPLOAD_VIDEO_PENDING = "UPLOAD_VIDEO_PENDING";
export const UPLOAD_VIDEO_REJECTED = "UPLOAD_VIDEO_REJECTED";
export const UPLOAD_VIDEO_FULFILLED = "UPLOAD_VIDEO_FULFILLED";

export const ADD_COVER_PHOTO_PENDING = "ADD_COVER_PHOTO_PENDING";
export const ADD_COVER_PHOTO_REJECTED = "ADD_COVER_PHOTO_REJECTED";
export const ADD_COVER_PHOTO_FULFILLED = "ADD_COVER_PHOTO_FULFILLED";

export const ADD_PHOTOS_URL_PENDING = "ADD_PHOTOS_URL_PENDING";
export const ADD_PHOTOS_URL_REJECTED = "ADD_PHOTOS_URL_REJECTED";
export const ADD_PHOTOS_URL_FULFILLED = "ADD_PHOTOS_URL_FULFILLED";

export const ADD_VIDEO_POST_PENDING = "ADD_VIDEO_POST_PENDING";
export const ADD_VIDEO_POST_REJECTED = "ADD_VIDEO_POST_REJECTED";
export const ADD_VIDEO_POST_FULFILLED = "ADD_VIDEO_POST_FULFILLED";

export const RESET_MEDIA_ATTACHMENT_PENDING = "RESET_MEDIA_ATTACHMENT_PENDING";
export const RESET_MEDIA_ATTACHMENT_REJECTED =
  "RESET_MEDIA_ATTACHMENTs_REJECTED";
export const RESET_MEDIA_ATTACHMENT_FULFILLED =
  "RESET_MEDIA_ATTACHMENT_FULFILLED";

export const CAPTURE_IMAGE = "CAPTURE_IMAGE";
export const STREAM_VIDEO = "STREAM_VIDEO";
const INITIAL_STATE = {
  files: [],
  type: "TEXTE",
  media: [],
  coverId: "",
  preview: false,
  coverUrl: "",
  photosUrl: [],
  photosIds: [],
  videoId: "",
  posts: {},
};
const loading = (state = INITIAL_STATE, { type }) => {
  switch (type) {
    case ADD_POST_PENDING:
    case GET_POST_PENDING:
    case DELETE_POST_PENDING:
    case UPLOAD_IMAGES_PENDING:
    case ADDED_MEDIA_POST_PENDING:
    case ADDED_MEDIA_POST_PENDING:
    case ADD_COVER_PHOTO_PENDING:
    case ADD_PHOTOS_URL_PENDING:
    case ADD_VIDEO_POST_PENDING:
      return true;
    case ADD_POST_REJECTED:
    case ADD_POST_FULFILLED:
    case GET_POST_REJECTED:
    case GET_POST_FULFILLED:
    case DELETE_POST_REJECTED:
    case DELETE_POST_FULFILLED:
    case UPLOAD_IMAGES_FULFILLED:
    case ADDED_MEDIA_POST_FULFILLED:
    case ADDED_MEDIA_POST_REJECTED:
    case ADD_COVER_PHOTO_FULFILLED:
    case ADD_COVER_PHOTO_REJECTED:
    case ADD_PHOTOS_URL_FULFILLED:
    case ADD_PHOTOS_URL_REJECTED:
    case ADD_VIDEO_POST_FULFILLED:
    case ADD_VIDEO_POST_REJECTED:
      return false;
    default:
      return false;
  }
};
const error = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ADD_POST_PENDING:
    case ADD_POST_FULFILLED:
    case GET_POST_PENDING:
    case GET_POST_FULFILLED:
    case DELETE_POST_PENDING:
    case DELETE_POST_FULFILLED:
    case ADDED_MEDIA_POST_PENDING:
    case ADDED_MEDIA_POST_FULFILLED:
      return null;
    case ADD_POST_REJECTED:
    case GET_POST_REJECTED:
    case DELETE_POST_REJECTED:
    case ADDED_MEDIA_POST_REJECTED:
      return payload;
    default:
      return null;
  }
};
const data = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ADD_POST_FULFILLED:
      return Object.assign({}, state, {
        files: [],
        type: "TEXTE",
      });
    case GET_POST_FULFILLED:
      return Object.assign({}, state, {
        posts: _.isEmpty(payload.data) ? null : payload.data,
      });
    case CAPTURE_IMAGE:
      return {
        ...state,
        type: "PHOTOS",
        files: state.files.concat(payload),
        photosUrl: state.files.concat(payload),
      };
    case UPLOAD_IMAGES_FULFILLED:
      return {
        ...state,
        type: "PHOTOS",
        files: state.files.concat(payload),
        photosUrl: state.files.concat(payload),
      };
    case STREAM_VIDEO:
      return Object.assign({}, state, {
        files: payload,
        type: "VIDEO",
      });
    case ADDED_MEDIA_POST_FULFILLED:
      return Object.assign({}, state, {
        files: state.files,
        type: state.type,
        media: _.isEmpty(payload.data) ? null : payload.data.files,
        preview: true,
        type: "PHOTOS",
      });
    case DELETE_MEDIA_FULFILLED:
      return Object.assign({}, state, {
        files: _.isEmpty(payload) ? [] : payload,
        photosUrl: _.isEmpty(payload) ? [] : payload,
        type: _.isEmpty(payload)
          ? "TEXTE"
          : state.type === "VIDEO"
          ? "TEXTE"
          : "PHOTOS",
      });
    case CHOOSE_FAVORI_FULFILLED:
      return Object.assign({}, state, {
        coverUrl: payload.file,
        photosUrl: payload.filtred,
        files: state.files,
        type: "PHOTOS",
      });
    case UPLOAD_VIDEO_FULFILLED:
      return Object.assign({}, state, {
        type: "VIDEO",
        files: payload,
      });
    case ADD_COVER_PHOTO_FULFILLED:
      return Object.assign({}, state, {
        coverId: _.isEmpty(payload) ? "" : payload,
        type: "PHOTOS",
      });
    case ADD_PHOTOS_URL_FULFILLED:
      return Object.assign({}, state, {
        photosIds: _.isEmpty(payload) ? [] : payload,
      });
    case ADD_VIDEO_POST_FULFILLED:
      return Object.assign({}, state, {
        videoId: _.isEmpty(payload) ? "" : payload,
        type: "VIDEO",
      });
    case RESET_MEDIA_ATTACHMENT_FULFILLED:
      return Object.assign({}, state, {
        files: [],
        type: "TEXTE",
        media: [],
        coverId: "",
        preview: false,
        coverUrl: "",
        photosUrl: [],
        photosIds: [],
        videoId: "",
        posts: {},
      });
    default:
      return state;
  }
};
export default combineReducers({ loading, error, data });
export const addPostCommunaute = (tok, description) => {
  return (dispatch, getState) => {
    dispatch({ type: ADD_POST_PENDING });
    let typePost = getState().Communaute.data.type;
    let cover = getState().Communaute.data.coverId;
    let photosIds = getState().Communaute.data.photosIds;
    let videoId = getState().Communaute.data.videoId;
    const data = {
      coverId: cover,
      description: description,
      photosIds: photosIds,
      typePoste: typePost,
      videoId: videoId,
    };
    const response = Service.post(`${API}api/creche/posts`, data, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: ADD_POST_FULFILLED, payload: res });
      dispatch(getPostCommunaute(tok, 1));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: ADD_POST_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
export const getPostCommunaute = (tok, offset) => {
  return (dispatch) => {
    dispatch({ type: ADD_POST_PENDING });

    const response = Service.get(
      `${API}api/creche/posts?offset=${offset}&path-size=20`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: GET_POST_FULFILLED, payload: res });
    });
    response.catch((err) => {
      dispatch({ type: GET_POST_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        let message = !_.isEmpty(err.response)
          ? err.response.data.message
          : null;
        dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
        dispatch(unAuthorized());
      }
    });
  };
};
export const deletePost = (tok, id, nbrElement) => {
  return (dispatch) => {
    dispatch({ type: DELETE_POST_PENDING });
    const response = Service.deleteOne(`${API}api/creche/posts/${id}`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: DELETE_POST_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: DELETE_POST_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
export const capturedData = (image) => {
  return (dispatch) => {
    image.lastModifiedDate = new Date();
    image.name = "capture image";
    dispatch({ type: CAPTURE_IMAGE, payload: image });
  };
};
export const streamVideo = (video) => {
  return (dispatch) => {
    dispatch({ type: STREAM_VIDEO, payload: video });
  };
};
export const deleteMedia = (dataPost, element) => {
  return (dispatch) => {
    if (dataPost.type === "PHOTOS") {
      dataPost.files.splice(dataPost.files.indexOf(element), 1);
      dispatch({ type: DELETE_MEDIA_FULFILLED, payload: dataPost.files });
    } else {
      dispatch({ type: DELETE_MEDIA_FULFILLED, payload: [] });
    }
  };
};
export const attachFiles = (files) => {
  return (dispatch) => {
    dispatch({ type: UPLOAD_IMAGES_FULFILLED, payload: files });
  };
};
export const attachVideo = (video) => {
  return (dispatch) => {
    dispatch({ type: UPLOAD_VIDEO_FULFILLED, payload: video });
  };
};
export const chooseFavori = (filtred, file) => {
  return (dispatch) => {
    dispatch({ type: CHOOSE_FAVORI_FULFILLED, payload: { filtred, file } });
  };
};
export const resetMediaAttachment = () => {
  return (dispatch) => {
    dispatch({ type: RESET_MEDIA_ATTACHMENT_FULFILLED, payload: [] });
  };
};
export const uploadVideo = (tok, data) => {
  return async (dispatch) => {
    dispatch({ type: ADD_POST_PENDING });
    let formPayload = new FormData();
    formPayload.append("file", data.video);
    try {
      const response = await Service.post(
        `${API}api/creche/files?category=VIDEO`,
        formPayload,
        {
          headers: { Authorization: `Bearer ${tok}` },
        }
      );
      let videoId = response.data.files.map((elem) => elem.fileId);
      dispatch({ type: ADD_VIDEO_POST_FULFILLED, payload: videoId[0] });
      dispatch(addPostCommunaute(tok, data.description));
    } catch (e) {
      let message = !_.isEmpty(e.response) ? e.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: ADD_COVER_PHOTO_REJECTED, payload: e });
      if (e.response.status === 401) {
        dispatch(unAuthorized());
      }
    }
  };
};
export const uploadPhotos = (tok, files) => {
  return async (dispatch) => {
    let coverId = "";
    let coverUrl = files.dataPost.coverUrl;
    let photosUrl = files.dataPost.photosUrl;

    if (!coverUrl) {
      coverUrl = photosUrl[0];
      photosUrl = photosUrl.filter(function(value, index) {
        if (index !== 0) {
          return value;
        }
      });
    }
    if (coverUrl) {
      dispatch({ type: ADD_POST_PENDING });
      let formPayload = new FormData();
      formPayload.append("file", coverUrl);
      try {
        const response = await Service.post(
          `${API}api/creche/files?category=PHOTO`,
          formPayload,
          {
            headers: { Authorization: `Bearer ${tok}` },
          }
        );
        coverId = response.data.files.map((elem) => elem.fileId);
        dispatch({ type: ADD_COVER_PHOTO_FULFILLED, payload: coverId[0] });
      } catch (e) {
        let message = !_.isEmpty(e.response) ? e.response.data.message : null;
        dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
        dispatch({ type: ADD_COVER_PHOTO_REJECTED, payload: e });
        if (e.response.status === 401) {
          dispatch(unAuthorized());
        }
      }
    }
    let photosIds = [];
    if (photosUrl.length) {
      dispatch({ type: ADD_POST_PENDING });
      let formPayload = new FormData();
      photosUrl.forEach(async (file) => {
        formPayload.append("file", file);
      });
      try {
        const response = await Service.post(
          `${API}api/creche/files?category=PHOTO`,
          formPayload,
          {
            headers: { Authorization: `Bearer ${tok}` },
          }
        );
        photosIds = response.data.files.map((elem) => elem.fileId);
        dispatch({ type: ADD_PHOTOS_URL_FULFILLED, payload: photosIds });
      } catch (e) {
        let message = !_.isEmpty(e.response) ? e.response.data.message : null;
        dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
        dispatch({ type: ADD_PHOTOS_URL_REJECTED, payload: photosIds });
        if (e.response.status === 401) {
          dispatch(unAuthorized());
        }
      }
    }
    if (photosIds || coverId) {
      dispatch(addPostCommunaute(tok, files.description));
    }
  };
};
export const uploadMomentPhotos = (tok, files) => (dispatch) => {
  dispatch({ type: ADD_POST_PENDING });
  let formPayload = new FormData();
  //formPayload.append("file", files.dataPost.files[0]);
  formPayload.append("file", files.dataPost.files[files.dataPost.files.length-1]);
  const response = Service.post(
    `${API}api/creche/files?category=PHOTO`,
    formPayload,
    {
      headers: { Authorization: `Bearer ${tok}` },
    }
  );
  response.then((res) => {
    let PhotosIds = [];
    let cover = res.data.files[0].fileId;
    dispatch({ type: ADD_COVER_PHOTO_FULFILLED, payload: cover });
    dispatch(
      addPostCommunauteFromMoment(
        tok,
        PhotosIds,
        files.description,
        files.dataPost.type,
        cover,
        files.parentsList
      )
    );
  });
  response.catch((err) => {
    let message = !_.isEmpty(err.response) ? err.response.data.message : null;
    dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
     if (err && err.response && err.response.status === 401) {
      dispatch(unAuthorized());
    }
  });
};

export const uploadMomentVideos = (tok, data) => (dispatch) => {
  dispatch({ type: ADD_POST_PENDING });
  let formPayload = new FormData();
  formPayload.append("file", data.video);
  const response = Service.post(
    `${API}api/creche/files?category=VIDEO`,
    formPayload,
    {
      headers: { Authorization: `Bearer ${tok}` },
    }
  );
  response.then((res) => {
    var videoIds = res.data.files[0].fileId;
    var postData = {
      videoIds: videoIds,
      parentsList: data.parentsList,
    };
    dispatch(addPostVideoCommunauteFromMoment(tok, postData));
  });
  response.catch((err) => {
     let message = !_.isEmpty(err.response) ? err.response.data.message : null;
    dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
    if (err && err.response && err.response.status === 401) {
      dispatch(unAuthorized());
    }
  });
};

export const addPostCommunauteFromMoment = (
  tok,
  photosIds,
  description,
  type,
  cover,
  parentsList
) => {
  return (dispatch, getState) => {
    let typePost = type;
    if ((type = "PHOTO")) {
      typePost = "PHOTOS";
    }
    const data = {
      coverId: cover,
      description: "",
      photosIds: photosIds,
      typePoste: typePost,
      enfantsIds: parentsList,
    };
    const response = Service.post(`${API}api/creche/posts`, data, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: ADD_POST_FULFILLED, payload: res.config.data });
      dispatch(getPostCommunaute(tok, 1));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: ADD_POST_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const addPostVideoCommunauteFromMoment = (tok, Postdata) => {
  var parentIds = Postdata.parentsList;
  var video = Postdata.videoIds;
  return (dispatch, getState) => {
    const data = {
      coverId: "",
      description: "",
      photosIds: [],
      enfantsIds: parentIds,
      typePoste: "VIDEO",
      videoId: video,
    };
    const response = Service.post(`${API}api/creche/posts`, data, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: ADD_POST_FULFILLED, payload: res });
      dispatch(getPostCommunaute(tok, 1));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: ADD_POST_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
